import { AllRoutes } from 'constants/routes';
import { IColumnSortingInfo } from 'types/table';

interface IDefaultColumnsSorting {
  [key: string]: IColumnSortingInfo[];
}

export const DefaultColumnsSorting: IDefaultColumnsSorting = {
  [AllRoutes.VehiclesMonitoring]: [
    { id: 'id', sortBy: null },
    { id: 'rippleId', sortBy: null },
    { id: 'version', sortBy: null },
    { id: 'createdAt', sortBy: null },
  ],
  [AllRoutes.TepDevicesManagement]: [{ id: 'createdAt', sortBy: null }],
  [AllRoutes.TepManagement]: [
    { id: 'name', sortBy: null },
    { id: 'device.imei', sortBy: null },
    { id: 'lease.company.name', sortBy: null },
    { id: 'lease.email', sortBy: null },
    { id: 'lease.plateNumber', sortBy: null },
    { id: 'lease.startOn', sortBy: null },
    { id: 'lease.endOn', sortBy: null },
    { id: 'lease.issuedAt', sortBy: null },
  ],
  [AllRoutes.TepOfficersNotifications]: [{ id: 'createdAt', sortBy: null }],
  [AllRoutes.TepClientNotifications]: [{ id: 'createdAt', sortBy: null }],
};
